"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapTerm = exports.useArrowHandling = exports.mergeElements = exports.handleHighlight = exports.getUniquePageMatches = exports.getResultPaths = exports.cleanWrappedElements = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = _interopRequireDefault(require("react"));
var _debug = _interopRequireDefault(require("debug"));
var _escapeStringRegexp = _interopRequireDefault(require("escape-string-regexp"));
var _constants = require("../constants");
var log = (0, _debug.default)('exchange:search:utils');
var isBrowserEnv = process.env.NODE_ENV !== 'test';
var mergeElements = exports.mergeElements = function mergeElements(refs) {
  var elements = refs.reduce(function (accum, currentRef) {
    if (currentRef !== null && currentRef !== void 0 && currentRef.current) {
      var targetElements = currentRef.current ? currentRef.current.getElements() : [];
      return [].concat((0, _toConsumableArray2.default)(accum), (0, _toConsumableArray2.default)(targetElements));
    }
    return accum;
  }, []);
  return elements;
};
var useArrowHandling = exports.useArrowHandling = function useArrowHandling(refs, dependencies) {
  return _react.default.useCallback(function (event) {
    var elements = mergeElements(refs);
    if (elements.length === 0) {
      return;
    }
    var selectedElementIndex = elements.findIndex(function (item) {
      return item === document.activeElement;
    });
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      if (selectedElementIndex === -1 || selectedElementIndex === elements.length - 1) {
        elements[0].focus();
        return;
      }
      elements[selectedElementIndex + 1].focus();
    }
    if (event.key === 'ArrowUp') {
      event.preventDefault();
      if (selectedElementIndex === -1 || selectedElementIndex === 0) {
        elements[elements.length - 1].focus();
        return;
      }
      elements[selectedElementIndex - 1].focus();
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [].concat((0, _toConsumableArray2.default)(dependencies), (0, _toConsumableArray2.default)(refs)));
};
var cleanWrappedElements = exports.cleanWrappedElements = function cleanWrappedElements(wrappedTerms) {
  log('cleaning wrapped elements', wrappedTerms);
  wrappedTerms.forEach(function (innerElement) {
    if (innerElement.parentNode) {
      // eslint-disable-next-line no-param-reassign
      innerElement.outerHTML = innerElement.innerHTML;
    }
  });
};

/**
 * CSS selectors of the elements (including descendants)
 * that should be ignored in the "wrapTerm" function.
 */
var elementsToIgnore = ['svg', 'style', 'section.bottom-nav', '#reviews-list', 'section[aria-label="API request panel"]', '[data-test-id="api-notebook"]', '[data-test-id="play-notebook"]'].join(', ');
var isAValidNodeElement = function isAValidNodeElement(node) {
  return node.nodeType === Node.TEXT_NODE || node.nodeType === Node.ELEMENT_NODE && !node.matches(elementsToIgnore);
};
var wrapTerm = exports.wrapTerm = function wrapTerm(element, term) {
  var wrappedTerms = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  if (!element || !term) {
    return wrappedTerms;
  }

  // Positive lookbehind: to be consistent with ANG and only work with prefix or words
  var expr = new RegExp("(?<=^|[^a-z])".concat((0, _escapeStringRegexp.default)(term)), 'ig');
  var _ref = element,
    shadowRoot = _ref.shadowRoot;
  var nodes = [].concat((0, _toConsumableArray2.default)(element.childNodes), (0, _toConsumableArray2.default)(shadowRoot ? shadowRoot.childNodes : []));
  nodes.filter(isAValidNodeElement).forEach(function (node) {
    if (node.nodeType === Node.TEXT_NODE) {
      var matches = node.nodeValue.match(expr);
      if (matches) {
        var parts = node.nodeValue.split(expr);
        // eslint-disable-next-line no-plusplus
        for (var n = 0; n < parts.length; n++) {
          if (n) {
            var highlight = document.createElement('span');
            highlight.style.backgroundColor = _constants.PORTAL_SEARCH_HIGHLIGHT_COLOR;
            highlight.dataset.index = wrappedTerms.length.toString();
            wrappedTerms.push(highlight);
            var style = element === null || element === void 0 ? void 0 : element.style;
            if (style) {
              style.textTransform = 'none';
            }
            var span = element.insertBefore(highlight, node);
            span.appendChild(document.createTextNode(matches[n - 1]));
          }
          if (parts[n]) {
            element.insertBefore(document.createTextNode(parts[n]), node);
          }
        }
        element.removeChild(node);
      }
    } else {
      wrapTerm(node, term, wrappedTerms);
    }
  });
  return wrappedTerms;
};
var handleHighlight = exports.handleHighlight = function handleHighlight(nextSelected, terms, event) {
  var _element$scrollIntoVi;
  event === null || event === void 0 || event.preventDefault();
  if (nextSelected === undefined || !terms.length) {
    return;
  }

  // Remove previous selected highlight if applicable
  terms.forEach(function (term) {
    var termStyle = term.style;
    if (termStyle) {
      termStyle.backgroundColor = _constants.PORTAL_SEARCH_HIGHLIGHT_COLOR;
    }
  });

  // Highlight next match
  var element = terms[nextSelected - 1];
  if (!element) {
    return;
  }
  (_element$scrollIntoVi = element.scrollIntoView) === null || _element$scrollIntoVi === void 0 || _element$scrollIntoVi.call(element);
  // this is because exchange-ui has a weird vertical 60px offset and scrollIntoView does not
  // show the element selected. To avoid annoying logs, run this only when not running in a test env
  if (isBrowserEnv) {
    var _global$scrollTo, _global;
    (_global$scrollTo = (_global = global).scrollTo) === null || _global$scrollTo === void 0 || _global$scrollTo.call(_global, document.documentElement.scrollLeft, document.documentElement.scrollTop - 200);
  }
  element.style.backgroundColor = _constants.PORTAL_SEARCH_HIGHLIGHT_SELECTED_COLOR;
};
var isTermsOrHomePage = function isTermsOrHomePage(_ref2) {
  var title = _ref2.title;
  return title === '.terms' || title === 'home';
};
var getUniquePageMatches = exports.getUniquePageMatches = function getUniquePageMatches(pages, pagesFromStore) {
  var orderedPages = [];
  var homePage = pages.find(function (_ref3) {
    var title = _ref3.title;
    return title === 'home';
  });

  // This is so that, if present, home always shows up first
  if (homePage) {
    orderedPages.push(homePage);
  }
  pagesFromStore.forEach(function (_ref4) {
    var name = _ref4.name;
    var pageInANGResults = pages.find(function (_ref5) {
      var title = _ref5.title;
      return title === name;
    });
    if (pageInANGResults && !isTermsOrHomePage(pageInANGResults)) {
      orderedPages.push(pageInANGResults);
    }
  });
  return orderedPages;
};
var getPagePaths = function getPagePaths(pages, pagesFromStore) {
  return pages.map(function (_ref6) {
    var _pagesFromStore$find$, _pagesFromStore$find;
    var title = _ref6.title;
    var path = (_pagesFromStore$find$ = (_pagesFromStore$find = pagesFromStore.find(function (_ref7) {
      var name = _ref7.name;
      return name === title;
    })) === null || _pagesFromStore$find === void 0 ? void 0 : _pagesFromStore$find.path) !== null && _pagesFromStore$find$ !== void 0 ? _pagesFromStore$find$ : title;
    return {
      path: "/pages/".concat(path)
    };
  });
};
var getResultPaths = exports.getResultPaths = function getResultPaths(pagesFromStore, pageMatches, customMatches) {
  var pagePaths = getPagePaths(pageMatches, pagesFromStore);
  return [].concat((0, _toConsumableArray2.default)(pagePaths), (0, _toConsumableArray2.default)(customMatches)).filter(function (result) {
    return result.path;
  });
};
//# sourceMappingURL=utils.js.map